import React from 'react';
import { Link } from 'react-router-dom';

const LeadGenerationMarketingPage = () => {
  return (
    <div>
      {/* Article Header */}
      <section
        className="h-[42vh] sm:h-[49vh] md:h-[56vh] bg-cover bg-center bg-no-repeat relative"
        style={{
          backgroundImage: "url('/images/Lloyd-James-Data-Marketing.webp')"
        }}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
        />

        {/* Banner Content */}
        <div className="relative z-10 flex items-center h-full px-4 sm:px-8 md:px-16 lg:px-24">
          <div className="text-center text-white max-w-6xl mx-auto">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal mb-4 sm:mb-6 leading-tight text-white">
              What is lead generation in data marketing?
            </h1>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-8 sm:py-10 md:py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="blog_inner">
            <div className="blog_lift_sidebar">
              <div className="blog_items">
                <div className="prose prose-lg max-w-none">
                  <p className="text-xl font-semibold text-gray-900 mb-6">
                    In marketing, the end goal of lead generation is to expand revenue. This is actioned by gaining the interest of potential customers through marketing activity.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-6">
                    How do you stimulate this interest in order to generate sales?
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    This process is crucial in the sales funnel, in the past data marketing methods like mail shots used to be enough. But as customers get more 'woke', and competition to gain their attention increases, sales teams look to lead generation through marketing tactics to generate business. A business within any industry and of any size can use a lead generation campaign within their strategy, and for both B2C and B2B inbound leads.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Gaining a good lead is the tricky part, it's key that your sales team don't burn daylight chasing cold leads that will never make their way down the lead funnel. By executing a lead generation strategy you aren't just generating marketing leads, you are also increasing brand awareness, building relationships, generating qualified leads, and ultimately this work will have a hand in the deals your sales team closes.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    <Link to="/product" className="text-pink-600 hover:text-pink-700 underline" onClick={() => window.scrollTo(0, 0)}>Click here</Link> to read more about RESIDENT, our market-leading data product that offers a single data view of UK consumers covering 96% of all UK households.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Your business is missing out on a massive revenue stream if you are not using marketing leads in your plan of action. With the rapid rise of technology and therefore platforms to advertise your services, your target audience can now access different media outlets including social media and other digital websites. Social media selling is hot right now along with Google ads and affiliate marketing.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-6">
                    Here is 5 ways to generate sales leads:
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Capturing interested customers through form fills on your website
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Generate leads through Google Ads
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Use direct emails to capture potential leads
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Use email lists
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Social media leads are great as these customers will be at the very top of your lead funnel
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-6">
                    85% of expert marketers say that lead generation marketing is the most important element in their marketing arsenal.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    In summary, their is no one size fits all in sales lead generation. The best way to combat this strategy and implement it into the day to day running of your business is to test and try different methods and see what works best for your ales team. The lead generation process can involve different platforms and approaches, a free lead generation audit call with our team can help you figure out how your business can develop the most effective campaign.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LeadGenerationMarketingPage;